const BKG_SIZE_CLASSES = 'h-37 sm:h-50';

export const LogoTopBkg1 = () => {
  return (
    <svg
      viewBox='0 0 1280 200'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={BKG_SIZE_CLASSES}
    >
      <g clip-path='url(#clip0_502_18027)'>
        <rect width='1280' height='200' fill='url(#paint0_linear_502_18027)' />
        <path d='M1280 0H0V240H1280V0Z' fill='url(#paint1_linear_502_18027)' />
        <path
          d='M351 525C483.548 525 591 408.818 591 265.5C591 122.182 483.548 6 351 6C218.452 6 111 122.182 111 265.5C111 408.818 218.452 525 351 525Z'
          fill='#C5DBFF'
        />
        <path
          opacity='0.6'
          d='M600.5 349C676.991 349 739 287.215 739 211C739 134.785 676.991 73 600.5 73C524.009 73 462 134.785 462 211C462 287.215 524.009 349 600.5 349Z'
          fill='#FEF0C7'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_502_18027'
          x1='1280'
          y1='154'
          x2='1280'
          y2='0'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#C5DBFF' />
          <stop offset='0.935' stop-color='#F5FAFF' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_502_18027'
          x1='1280'
          y1='184.8'
          x2='1280'
          y2='0'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#C5DBFF' />
          <stop offset='0.935' stop-color='#F5FAFF' />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const LogoTopBkg2 = () => {
  return (
    <svg
      viewBox='0 0 1280 200'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={BKG_SIZE_CLASSES}
    >
      <g clip-path='url(#clip0_503_18048)'>
        <rect width='1280' height='200' fill='url(#paint0_linear_503_18048)' />
        <path d='M1280 0H0V240H1280V0Z' fill='url(#paint1_linear_503_18048)' />
        <path
          opacity='0.7'
          d='M312 558C444.548 558 552 441.818 552 298.5C552 155.182 444.548 39 312 39C179.452 39 72 155.182 72 298.5C72 441.818 179.452 558 312 558Z'
          fill='#ECFDF3'
        />
        <path
          opacity='0.4'
          d='M589.5 523C704.099 523 797 422.488 797 298.5C797 174.512 704.099 74 589.5 74C474.901 74 382 174.512 382 298.5C382 422.488 474.901 523 589.5 523Z'
          fill='#A9EFC5'
        />
        <path
          opacity='0.7'
          d='M1177.5 132C1253.99 132 1316 70.2153 1316 -6C1316 -82.2153 1253.99 -144 1177.5 -144C1101.01 -144 1039 -82.2153 1039 -6C1039 70.2153 1101.01 132 1177.5 132Z'
          fill='#FEF0C7'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_503_18048'
          x1='1280'
          y1='154'
          x2='1280'
          y2='0'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#C5DBFF' />
          <stop offset='0.935' stop-color='#F5FAFF' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_503_18048'
          x1='1280'
          y1='184.8'
          x2='1280'
          y2='0'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#C5DBFF' />
          <stop offset='0.935' stop-color='#F5FAFF' />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const LogoTopBkg3 = () => {
  return (
    <svg
      viewBox='0 0 1280 200'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={BKG_SIZE_CLASSES}
    >
      <g clip-path='url(#clip0_503_18060)'>
        <rect width='1280' height='200' fill='#C5DBFF' />
        <path d='M1280 0H0V240H1280V0Z' fill='#3339CC' fill-opacity='0.2' />
        <path
          opacity='0.9'
          d='M216 139C355.728 139 469 16.5499 469 -134.5C469 -285.55 355.728 -408 216 -408C76.272 -408 -37 -285.55 -37 -134.5C-37 16.5499 76.272 139 216 139Z'
          fill='#C5DBFF'
        />
        <path
          opacity='0.3'
          d='M1047 -13.5C1109.68 -13.5 1160.5 37.3157 1160.5 100C1160.5 162.684 1109.68 213.5 1047 213.5C984.316 213.5 933.5 162.684 933.5 100C933.5 37.3157 984.316 -13.5 1047 -13.5Z'
          stroke='#2F37ED'
          stroke-width='5'
        />
        <path
          opacity='0.8'
          d='M363 326C444.186 326 510 260.41 510 179.5C510 98.5903 444.186 33 363 33C281.814 33 216 98.5903 216 179.5C216 260.41 281.814 326 363 326Z'
          fill='#FEF0C7'
        />
        <path
          opacity='0.3'
          d='M1118.5 171C1194.99 171 1257 109.215 1257 33C1257 -43.2153 1194.99 -105 1118.5 -105C1042.01 -105 980 -43.2153 980 33C980 109.215 1042.01 171 1118.5 171Z'
          fill='#2F37ED'
        />
        <path
          opacity='0.6'
          d='M543.5 -131.5C626.343 -131.5 693.5 -64.3427 693.5 18.5C693.5 101.343 626.343 168.5 543.5 168.5C460.657 168.5 393.5 101.343 393.5 18.5C393.5 -64.3427 460.657 -131.5 543.5 -131.5Z'
          stroke='#FFCD4B'
          stroke-width='5'
        />
        <path
          opacity='0.6'
          d='M822 53.5C869.22 53.5 907.5 91.7797 907.5 139C907.5 186.22 869.22 224.5 822 224.5C774.78 224.5 736.5 186.22 736.5 139C736.5 91.7797 774.78 53.5 822 53.5Z'
          stroke='#A9EFC5'
          stroke-width='5'
        />
        <path
          opacity='0.4'
          d='M812.5 441C897.828 441 967 366.008 967 273.5C967 180.992 897.828 106 812.5 106C727.172 106 658 180.992 658 273.5C658 366.008 727.172 441 812.5 441Z'
          fill='#A9EFC5'
        />
      </g>
    </svg>
  );
};
export const LogoTopBkg4 = () => {
  return (
    <svg
      viewBox='0 0 1280 200'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={BKG_SIZE_CLASSES}
      preserveAspectRatio='xMaxYMid slice'
    >
      <g clip-path='url(#clip0_503_18239)'>
        <rect width='1280' height='200' fill='#C5DBFF' />
        <path d='M1280 0H0V240H1280V0Z' fill='#3339CC' fill-opacity='0.2' />
        <path
          opacity='0.3'
          d='M1166.66 -189.294L949.919 -120.922C941.68 -118.323 937.109 -109.541 939.71 -101.308L1028.88 180.914C1031.48 189.147 1040.27 193.714 1048.51 191.115L1265.24 122.744C1273.48 120.144 1278.06 111.363 1275.45 103.129L1186.29 -179.092C1183.68 -187.326 1174.9 -191.893 1166.66 -189.294Z'
          fill='#2F37ED'
        />
        <path
          opacity='0.9'
          d='M216 139C355.728 139 469 16.5499 469 -134.5C469 -285.55 355.728 -408 216 -408C76.272 -408 -37 -285.55 -37 -134.5C-37 16.5499 76.272 139 216 139Z'
          fill='#C5DBFF'
        />
        <path
          opacity='0.5'
          d='M488.618 91.6942L287.505 17.5494C274.697 12.8277 260.484 19.3743 255.759 32.1716L181.556 233.128C176.831 245.926 183.382 260.128 196.19 264.849L397.303 338.994C410.111 343.716 424.324 337.169 429.049 324.372L503.252 123.415C507.977 110.618 501.426 96.4159 488.618 91.6942Z'
          fill='#FFCD4B'
        />
        <path
          opacity='0.4'
          d='M755 178C830.663 178 892 116.663 892 41C892 -34.663 830.663 -96 755 -96C679.337 -96 618 -34.663 618 41C618 116.663 679.337 178 755 178Z'
          fill='#A9EFC5'
        />
      </g>
    </svg>
  );
};

const BKG_SVGS = [LogoTopBkg1, LogoTopBkg2, LogoTopBkg3, LogoTopBkg4];

/** Converts a string to a number from 1 <-> [# of background banner images], inclusive. */
function hashStringToRange(str: string) {
  let hash = 0;
  // The hash function isn't really significant, just need to convert a string to a number
  // in a way that is consistent across page loads
  for (const char of str) {
    hash = (hash << 5) - hash + char.charCodeAt(0);
    hash |= 0; // Constrain to 32bit integer
  }

  // Math.abs() b/c JS modulo can return negative numbers
  return Math.abs(hash % BKG_SVGS.length);
}

/** Displays one of four random SVG designs for the top banner background.
 * We use different designs just to add visual variety in the app and to reduce the
 * feeling of same-yness on pages directory pages that lack content and have no avatars.
 */
export const LogoTopBkg = () => {
  // Select a random bkg image based on the URL, so it stays consistent across page reloads & doesn't require passing in
  // an id via prop
  let bkg;
  // This use of 'window' will break our static site generation in mise:build unless wrapped in a try/catch
  try {
    let bkgIndex = hashStringToRange(window.location.href.split('?')[0]);

    // Safety check just in case the hash function fails for some reason
    if (bkgIndex < 0 || bkgIndex > BKG_SVGS.length - 1) {
      bkgIndex = 0;
    }

    bkg = BKG_SVGS[bkgIndex];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return null;
  }

  return (
    <div className='inline-flex border-b-1 border-b-gray-100'>
      {bkg()}
      {/* Repeat the pattern for wide screen displays */}
      <div className='hidden xl:block'>{bkg()}</div>
    </div>
  );
};
